// =================== URL APIs ============================
// ============= en caso de incluir traduccion ==================
export const randomNumber = (min_number = 1000000000, max_number = 9999999999, break_number) =>{
	let result;
	do {
		result = Math.floor(Math.random() * (min_number - max_number + 1)) + max_number;
	} while (break_number !== undefined && result === break_number);
	return result;
};
const validInt = (number) => {
	return number === null || isNaN(parseInt(number)) ? 0 : parseInt(number);
};
function bankerRounding(amount, decimalPlaces) {
	
	let decimal_places 			= decimalPlaces || 0;
	let potencia 				= Math.pow(10, decimal_places);
	let avoid_rounding_error 	= +(decimal_places ? amount * potencia : amount).toFixed(8); // Avoid rounding errors
	let int_rounding_error 		= Math.floor(avoid_rounding_error); 
	let decimal_rounding_error 	= avoid_rounding_error - int_rounding_error;
	let allow_rounding_error 	= parseFloat('1e-8'); // Allow for rounding errors in decimal_rounding_error
	
	let rounding_number 		= (decimal_rounding_error > 0.5 - allow_rounding_error && decimal_rounding_error < 0.5 + allow_rounding_error) ? ((int_rounding_error % 2 === 0) ? int_rounding_error : int_rounding_error + 1) : Math.round(avoid_rounding_error);
	
	return decimal_places ? rounding_number / potencia : rounding_number;
};
const formatCurrency = (amount = 0, shopify_rounding = null, locale = 'en-MX', currency = 'MXN') => {
	
	if( amount === null || isNaN( parseFloat( amount ) ) || typeof amount === 'string' ){
		
		return formatCurrency(0, false);
	}
	else{
		
		const formatterCurrency = new Intl.NumberFormat( locale, { style: 'currency', currency: currency, minimumFractionDigits: 2 } );
		const parts_format      = formatterCurrency.formatToParts( 1000 );
		
		let regexp_symbol               = new RegExp(`([${ parts_format[0].value }])`, 'g');
		let regexp_separador_millares   = new RegExp(`([${ parts_format[2].value }])`, 'g');
		let regexp_separador_decimal    = new RegExp(`([${ parts_format[parts_format.length - 2].value }])`, 'g');
		
		if( shopify_rounding != null ){
			
			amount = ( shopify_rounding ? bankerRounding(amount, 2) : amount / 100 );
		}
		let format = formatterCurrency.format( amount );
		
		let number = parseFloat( format.replace( regexp_symbol, '').replace( regexp_separador_millares, '' ).replace( regexp_separador_decimal, '.' ) );
		
		return { format, number };
	}
};
const compareSortObject = ( is_asc, data_sort, current_item, next_item ) => {
	
	if( current_item[data_sort] > next_item[data_sort] ){
		
		return is_asc === 'asc' ? 1 : -1;
	}
	else if( current_item[data_sort] < next_item[data_sort] ){
		
		return is_asc === 'asc' ? -1 : 1;
	}
	else{
		
		return 0;
	}
};
export const calcDiscountPrice = ( price, discount, quantity ) =>{
	
	return ( Math.round( price * 100 ) - parseInt( ( ( Math.round( price * 100 ) * discount * quantity ) / 100 ).toString().split('.')[0] ) / quantity );
};
export const formatData = {
	validInt: validInt,
	currency: formatCurrency,
	validPhoneNumber(phone, list_phone_codes){
		if (!phone || !list_phone_codes?.length) {
			return {
				code: '52',
				country_code: 'MX',
				number: '',
				format: ''
			};
		}

		if(phone?.code){
			return phone
		}

		try {
			phone = phone?.replace(/([ +])+/g, '');
			
			// Si el número tiene menos de 10 dígitos, usa valores por defecto
			if (phone.length < 10) {
				return {
					code: '52',
					country_code: 'MX',
					number: phone ? `+52${phone}` : '',
					format: phone ? `+52${phone}` : ''
				};
			}

			// Obtiene el código (todos los dígitos excepto los últimos 10)
			let code = phone?.length > 10 ? phone.slice(0, -10) : '52';
			let numberPart = phone.slice(-10);

			// Busca el código en la lista
			let index_country = list_phone_codes.findIndex(item => 
				item.phone_code === parseInt(code)
			);

			// Si no encuentra el código, usa MX
			let country_code = index_country < 0 ? 'MX' : list_phone_codes[index_country].id.split('-')[0];
			code = index_country < 0 ? '52' : code;

			return {
				code,
				country_code,
				number: `${numberPart}`,
				format: `+${code}${numberPart}`
			};
		} catch (error) {
			return {
				code: '52',
				country_code: 'MX',
				number: phone ? `${phone}` : '',
				format: phone ? `+52${phone}` : ''
			};
		}
	},
	draftOrder(order_data, preorder_bundle_list, preorder_standard_list){
		
		let line_items = [];
		let skus = [];
		let total_cart = 0;
		let discounts_stock = [];
		if( ['cart', 'save-later'].includes( order_data.product_origin ) || ( order_data.product_origin.indexOf('pre-order') >= 0 && order_data.product_origin.indexOf('complete') >= 0 ) ){
			
			for (const item_variant of order_data.products) {
				
				skus.push( item_variant.sku );
				let line_item 			= {
					variant_id	: item_variant.variant_id,
					quantity	: item_variant.quantity
				};
				if( item_variant.discounts.stock.value > 0 && item_variant.inventory_quantity >= item_variant.discounts.stock.min_stock ){
					
					discounts_stock.push({
						sku			: item_variant.sku,
						value		: item_variant.discounts.stock.value,
						min_stock	: item_variant.discounts.stock.min_stock
					});
				}
				let discount_price 		= calcDiscountPrice( item_variant.price, item_variant.total_discount, item_variant.quantity );
				if( item_variant.price > 0 && item_variant.total_discount > 0 && item_variant.discount_type === 'percentage' ){
					
					let percentage = 0;
					if( item_variant.discounts.coupon.percentage.value ){
						
						percentage = 100 - ( ( 100 - item_variant.total_discount ) * ( ( 100 - item_variant.discounts.coupon.percentage.value ) / 100 ) );
						
					}
					else{
						
						percentage = item_variant.total_discount;
					}
					
					discount_price = calcDiscountPrice( item_variant.price, 100 - percentage, item_variant.quantity );
					
					line_item.applied_discount = { 
						value_type	: 'percentage', 
						value		: percentage, 
						amount		: formatCurrency( discount_price * parseInt(item_variant.quantity), false ).number 
					};
					total_cart += formatCurrency( discount_price * parseInt(item_variant.quantity), false ).number;
				}
				else if( item_variant.price > 0 && item_variant.total_discount > 0 && item_variant.discount_type === 'mixed_amount' ){
					
					line_item.applied_discount = { 
						value_type	: 'fixed_amount', 
						value		: ( ( ( ( item_variant.price - discount_price ) * item_variant.quantity ) + item_variant.discounts.coupon.fixed ) / item_variant.quantity ), 
						amount		: ( ( item_variant.price - discount_price ) * item_variant.quantity ) + item_variant.discounts.coupon.fixed
					};
					total_cart += formatCurrency( discount_price * item_variant.quantity, false ).number - item_variant.discounts.coupon.fixed;
				}
				line_items.push( line_item );
			}
		}
		else if( order_data.product_origin.indexOf('pre-order') >= 0 && order_data.product_origin.indexOf('advance') >= 0 ){
			
			line_items.push({
				title	: order_data.products[0].title,
				sku		: order_data.products[0].sku,
				quantity: order_data.products[0].quantity,
				price	: order_data.products[0].price
			})
		}
		let order_tags = [
			'ISCATA1OG',
			order_data.product_origin.indexOf('pre-order') >= 0 ? order_data.product_origin.toUpperCase() : ''
		].filter( (item) => item != '' );
		if( discounts_stock.length > 0 ){

			order_tags = order_tags.concat( discounts_stock.map( (item) => { return `${ item.sku }-DISCOUNT-${ item.value }-MIN-STOCK-${ item.min_stock }` }) );
		}
		let draft_order = {
			tags            : order_tags.join(', '),
			note_attributes : [
				{
					name    : 'business',
					value   :  ''
				},
				{
					name    : 'is_dropshipping',
					value   : false
				},
				{
					name    : 'payment_method',
					value   :  ''
				},
				{
					name    : 'need_invoice',
					value   :  ''
				},
				{
					name    : 'coupon',
					value   : ''
				},
				{
					name    : 'coupon_id',
					value   : ''
				},
				{
					name    : 'product_origins',
					value   : order_data.product_origin
				}
			],
			customer        : { 
				id: null 
			},
			line_items      : line_items
		};
		return {
			shopify_draft_order		: draft_order,
			product_origin			: order_data.product_origin,
			preorder_bundle_list	: preorder_bundle_list,
			preorder_standard_list	: preorder_standard_list
		};
	}
};
export const arrayHelpers = {
	sortArray ( array, data_sort, is_asc = 'asc' ){
		
		return array.length > 0 && array[0][data_sort] != undefined ? array.sort( (current_item, next_item) => { return compareSortObject(is_asc, data_sort, current_item, next_item); }) : array;
	},
	sortArrayProducts ( array, data_sort ){
		
		let sort_values = [{ value: 'best-selling', field: 'default_sort' }, { value: 'price-asc', field: 'min_price' }, { value: 'price-desc', field: 'min_price' }, { value: 'created', field: 'created_at' }];
		let index_sort = sort_values.findIndex( (item) => item.value === data_sort );
		
		if( sort_values[index_sort].field === 'default_sort' ){
			
			array = array.map( (item) => {
				
				return item.sort( (current_item, next_item) => { return compareSortObject('asc', sort_values[index_sort].field, current_item, next_item); });
			}).flat();
			
			return array;
		}
		else{
			
			array = array.flat();
			return array.length > 0 && array[0][sort_values[index_sort].field] != undefined ? array.sort( (current_item, next_item) => { return compareSortObject(data_sort === 'price-desc' ? 'desc' : 'asc', sort_values[index_sort].field, current_item, next_item); }) : array;
		}
		
	},
	chunkArray ( array, chunk_size ){
		
		let results = [];
		while ( array.length ) {
			
			results.push( array.splice( 0, chunk_size ) );
		}
		return results;
	}
};
export const validUploadFile = (file, input_file_name, max_size, old_file_path, extra_data) => {
	let file_types = {
		excel: ['.xls', '.xlsx'],
		image: ['png', 'jpeg', 'jpg', 'webp']
	}
	let name_file = file.name.split('\\')[ file.name.split('\\').length - 1 ];
	let regex = new RegExp(`^([a-zA-Z0-9\s_\\\-: ()-_])+(${ file_types[extra_data.category_file].join('|') })$`);
	
	if ( regex.test( name_file.toLowerCase() ) && file.size <= max_size ) {
		
		let formData = new FormData();
		formData.append( input_file_name, file);
		formData.append( 'max_size', max_size );
		formData.append( 'old_file_path', old_file_path ? old_file_path : '' );
		
		if( extra_data.body ){
			
			for (const item_data of extra_data.body) {
				
				formData.append( item_data.name, item_data.value );
			}
		}
		return { success: true, data: formData };
	}
	else if ( !regex.test( name_file.toLowerCase() ) ){
		
		return { success: false, title: 'Error: Upload File', message: `The selected file type is not as expected (${ file_types[extra_data.category_file].join(', ') }) or file name contains special characters` };
	}
	else{
		
		return { success: false, title: 'Error: Upload File', message: 'This file weighs more than 100mb, it cannot be uploaded' };
	}
};
export const effectSlider = (id_slider, count_items, ms_delay_effect) => {
	
	if( document.getElementById(id_slider) && document.getElementById(id_slider).getElementsByClassName('show-item-carousel')[0] ){
		
		let name_slider = id_slider.replace('slider-', '');
		
		let current_id 		= document.getElementById(id_slider)?.getElementsByClassName('show-item-carousel')[0].id;
		let current_index 	= parseInt(current_id.replace(`item-carousel-${name_slider}-`, ''));
		let next_index 		= current_index + 1 <= count_items ? current_index + 1 : 1;
		let next_id 		= `item-carousel-${name_slider}-${next_index}`;
		
		if( document.getElementById(next_id) ){
			
			document.getElementById(next_id).classList.add('show-item-carousel');
			document.getElementById(next_id).classList.remove('hide-item-carousel');
			if( document.getElementById(current_id) != null ){
				document.getElementById(current_id).classList.add('hide-item-carousel');
				setTimeout(() => {
					if( document.getElementById(current_id) != null ){
						document.getElementById(current_id).classList.remove('hide-item-carousel','show-item-carousel');
					}
				}, ms_delay_effect);
			}
		}
		
	}
}